import { http, type AuthTokens } from '@shared/api';

export type OtpChannel = 'EMAIL' | 'SMS';

export interface RegisterRequest {
  email: string;
  password?: string;
}

export interface RegisterResponse {
  userId: string;
  role: 'PRODUCER';
  message?: string;
}

export interface VerifyRequest {
  identity: string;
  channel: OtpChannel;
  code: string;
}

export interface LoginPasswordRequest {
  identity: string;
  password: string;
}

export interface OtpRequest {
  identity: string;
  channel: OtpChannel;
}

export interface OtpLoginRequest {
  identity: string;
  channel: OtpChannel;
  code: string;
}

export const authApi = {
  register: (body: RegisterRequest) =>
    http.post('auth/register', { json: body }).json<RegisterResponse>(),

  verify: (body: VerifyRequest) => http.post('auth/verify', { json: body }).json<AuthTokens>(),

  loginPassword: (body: LoginPasswordRequest) =>
    http.post('auth/login', { json: body }).json<AuthTokens>(),

  requestOtp: (body: OtpRequest) => http.post('auth/otp/request', { json: body }).json<void>(),

  loginOtp: (body: OtpLoginRequest) => http.post('auth/otp/login', { json: body }).json<AuthTokens>(),

  refresh: (refreshToken: string) =>
    http.post('auth/refresh', { json: { refreshToken } }).json<AuthTokens>(),

  logout: (refreshToken: string) =>
    http.post('auth/logout', { json: { refreshToken } }).json<void>(),

  // §4.4 Forgot password. Always 202 — backend masks user existence.
  requestPasswordReset: (identity: string) =>
    http
      .post('auth/password/reset/request', {
        json: { identity, channel: 'EMAIL' satisfies OtpChannel },
      })
      .json<void>(),

  confirmPasswordReset: (body: {
    identity: string;
    code: string;
    newPassword: string;
  }) =>
    http
      .post('auth/password/reset/confirm', {
        json: { ...body, channel: 'EMAIL' satisfies OtpChannel },
      })
      .json<void>(),
};
